import { EventEmitter, Component, Input, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Este componente sirve para mostrar un chatbot. Se le debe pasar como Inputs obligatorios para su buen funcionamiento
 * un [Payload]{@link IChatbotPayload}, una clave privada, el KID del chatbot y el environment donde está el producto actualmente.
 * También se ha de definir el entorno en el que estará funcionando el chatbot.
 *
 * @example
 * <ucc-chatbot
 *  [showChatbot]="showChatbot"
 *  [chatbotText]="chatbotText"
 *  [chatbotErrorText]="chatbotErrorText"
 *  [expandedChatbot]="expandedChatbot"
 *  [token]="token"
 *  [environment]="environment">
 * </ucc-chatbot>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function ChatbotComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} }
function ChatbotComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.chatbotText);
} }
function ChatbotComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵlistener("click", function ChatbotComponent_div_0_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onChatbotClick(); });
    ɵngcc0.ɵɵtemplate(2, ChatbotComponent_div_0_div_2_Template, 2, 0, "div", 3);
    ɵngcc0.ɵɵelement(3, "img", 4);
    ɵngcc0.ɵɵtemplate(4, ChatbotComponent_div_0_span_4_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.getChatAgentId());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("disabled", ctx_r0.isLoading ? true : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLoading);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.expandedChatbot);
} }
class ChatbotComponent {
    constructor() {
        /** Propiedad que permite mostrar u ocultar el chatbot. De manera predeterminada se muestra el chatbot */
        this.showChatbot = true;
        /** Texto que aparece a la derecha de la imagen del chatbot */
        this.chatbotText = null;
        /** Texto que aparece en un alert si sucede algún error con el chatbot */
        this.chatbotErrorText = null;
        /** Token firmado obligatorio para que el Chatbot pueda funcionar correctamente. Se debe obtener del backend. */
        this.token = null;
        /** Propiedad que permite que el Chatbot esté expandido o no. De manera predeterminada está expandido. */
        this.expandedChatbot = true;
        /** Permite definir la URL para la creación del Chatbot. Es una propiedad obligatoria */
        this.createChatUrl = null;
        /** Emite un evento cuando se hace click la zona del Chatbot. Se utiliza para iniciar la ventana del Chatbot */
        this.startingChat = new EventEmitter();
        /** @ignore */
        this._isLoading = false;
    }
    /** @ignore */
    onChatbotClick() {
        if (!this._isLoading) {
            this._isLoading = true;
            this.token ? this.openChatbotWindow(this.token) : this.startingChat.emit();
        }
    }
    /** @ignore */
    getChatAgentId() {
        return this.expandedChatbot ? 'ChatAgent' : 'ChatAgentmin';
    }
    /** Método que se utiliza para abrir la ventana del Chatbot
     *
     * @param token Token firmado obligatorio para que el Chatbot pueda funcionar correctamente
     */
    openChatbotWindow(token) {
        const target = 'wkLuca';
        const screenHeight = window.screen.height;
        let appHeight = 800;
        const appWidth = 800;
        if (screenHeight * 1.25 <= 1080) {
            appHeight = 750;
        }
        /* eslint-disable max-len */
        const windowConfig = 'width=' + appWidth + ',height=' + appHeight + ',' + 'scrollbars=no,location=no,menubar=no,status=no,titlebar=no,toolbar=no,resizable=yes';
        /* eslint-enable max-len */
        const chatWindow = window.open('', target, windowConfig);
        const container = chatWindow.document.createElement('div');
        chatWindow.document.body.appendChild(container);
        const chatForm = chatWindow.document.createElement('form');
        chatForm.id = 'chat_opener';
        chatForm.target = target;
        chatForm.method = 'POST';
        chatForm.action = this.createChatUrl;
        container.appendChild(chatForm);
        const chatInput = chatWindow.document.createElement('input');
        chatInput.type = 'hidden';
        chatInput.name = 'id';
        chatInput.value = token !== null && token !== void 0 ? token : this.token;
        chatForm.appendChild(chatInput);
        const chatInput2 = chatWindow.document.createElement('input');
        chatInput2.type = 'hidden';
        chatInput2.name = 'strategy';
        chatInput2.value = '2';
        chatForm.appendChild(chatInput2);
        chatWindow.document.body.appendChild(chatForm);
        if (chatWindow) {
            chatForm.submit();
            chatWindow.focus();
        }
        else {
            alert(this.chatbotErrorText);
        }
        this._isLoading = false;
    }
    /** @ignore */
    get isLoading() {
        return this._isLoading;
    }
}
ChatbotComponent.ɵfac = function ChatbotComponent_Factory(t) { return new (t || ChatbotComponent)(); };
ChatbotComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ChatbotComponent, selectors: [["ucc-chatbot"]], inputs: { showChatbot: "showChatbot", chatbotText: "chatbotText", chatbotErrorText: "chatbotErrorText", token: "token", expandedChatbot: "expandedChatbot", createChatUrl: "createChatUrl" }, outputs: { startingChat: "startingChat" }, decls: 1, vars: 1, consts: [[3, "id", 4, "ngIf"], [3, "id"], [1, "chatbotContainer", 3, "click"], ["class", "loadingAnimationChatbot", 4, "ngIf"], ["id", "LucaNew", "src", "framework/assets/images/chatbotIcon.png", 1, "chatbotIcon", "loadingSpinner"], ["class", "chatbotText", 4, "ngIf"], [1, "loadingAnimationChatbot"], [1, "loadingSpinner"], [1, "chatbotText"]], template: function ChatbotComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ChatbotComponent_div_0_Template, 5, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showChatbot);
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]     #ChatAgent{resize:none;font-size:13px;text-align:left;width:300px;z-index:16543210;position:fixed;right:32px;bottom:45px}[_nghost-%COMP%]     #ChatAgent .chatbotContainer{padding:10px;border-radius:16px;background-color:#0081c6;color:#fff;cursor:pointer;align-items:center}[_nghost-%COMP%]     #ChatAgent .chatbotContainer[disabled]{cursor:default!important}[_nghost-%COMP%]     #ChatAgent .chatbotText{padding-left:5px}[_nghost-%COMP%]     #ChatAgentmin{resize:none;font-size:13px;text-align:left;z-index:16543210;position:fixed;width:70px;right:32px;bottom:45px}[_nghost-%COMP%]     #ChatAgentmin .chatbotContainer{padding:10px;cursor:pointer;background-color:#0081c6;color:#fff;border-radius:36px}[_nghost-%COMP%]     .chatbotIcon{border:none 0px #fff;vertical-align:middle;width:50px}[_nghost-%COMP%]     .close{float:right;font-size:18px;line-height:1;text-shadow:0 1px 0 #fff;padding:0;cursor:pointer;background:0 0;border:0;top:15px;position:relative;right:2px;color:#fff;opacity:1}"] });
ChatbotComponent.propDecorators = {
    showChatbot: [{ type: Input }],
    chatbotText: [{ type: Input }],
    chatbotErrorText: [{ type: Input }],
    token: [{ type: Input }],
    expandedChatbot: [{ type: Input }],
    createChatUrl: [{ type: Input }],
    startingChat: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChatbotComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-chatbot',
                template: "<div *ngIf=\"showChatbot\" [id]=\"getChatAgentId()\">\n  <div class=\"chatbotContainer\" (click)=\"onChatbotClick()\" [attr.disabled]=\"isLoading ? true : null\">  \n    <div *ngIf=\"isLoading\" class=\"loadingAnimationChatbot\">\n      <div class=\"loadingSpinner\"></div>\n    </div>\n    <img id=\"LucaNew\" class=\"chatbotIcon loadingSpinner\" src=\"framework/assets/images/chatbotIcon.png\">\n    <span *ngIf=\"expandedChatbot\" class=\"chatbotText\">{{ chatbotText }}</span>\n  </div>\n</div>",
                styles: [":host ::ng-deep #ChatAgent{resize:none;font-size:13px;text-align:left;width:300px;z-index:16543210;position:fixed;right:32px;bottom:45px}:host ::ng-deep #ChatAgent .chatbotContainer{padding:10px;border-radius:16px;background-color:#0081c6;color:#fff;cursor:pointer;align-items:center}:host ::ng-deep #ChatAgent .chatbotContainer[disabled]{cursor:default!important}:host ::ng-deep #ChatAgent .chatbotText{padding-left:5px}:host ::ng-deep #ChatAgentmin{resize:none;font-size:13px;text-align:left;z-index:16543210;position:fixed;width:70px;right:32px;bottom:45px}:host ::ng-deep #ChatAgentmin .chatbotContainer{padding:10px;cursor:pointer;background-color:#0081c6;color:#fff;border-radius:36px}:host ::ng-deep .chatbotIcon{border:none 0px #fff;vertical-align:middle;width:50px}:host ::ng-deep .close{float:right;font-size:18px;line-height:1;text-shadow:0 1px 0 #fff;padding:0;cursor:pointer;background:0 0;border:0;top:15px;position:relative;right:2px;color:#fff;opacity:1}\n"]
            }]
    }], function () { return []; }, { showChatbot: [{
            type: Input
        }], chatbotText: [{
            type: Input
        }], chatbotErrorText: [{
            type: Input
        }], token: [{
            type: Input
        }], expandedChatbot: [{
            type: Input
        }], createChatUrl: [{
            type: Input
        }], startingChat: [{
            type: Output
        }] }); })();

class ChatbotModule {
}
ChatbotModule.ɵfac = function ChatbotModule_Factory(t) { return new (t || ChatbotModule)(); };
ChatbotModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ChatbotModule });
ChatbotModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChatbotModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    ChatbotComponent
                ],
                exports: [
                    ChatbotComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChatbotModule, { declarations: function () { return [ChatbotComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [ChatbotComponent]; } }); })();

class UccChatbotModule {
}
UccChatbotModule.ɵfac = function UccChatbotModule_Factory(t) { return new (t || UccChatbotModule)(); };
UccChatbotModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UccChatbotModule });
UccChatbotModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ChatbotModule
        ], ChatbotModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UccChatbotModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ChatbotModule
                ],
                exports: [
                    ChatbotModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UccChatbotModule, { imports: function () { return [CommonModule, ChatbotModule]; }, exports: function () { return [ChatbotModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ChatbotComponent, ChatbotModule, UccChatbotModule };

